const selectors = {
  customerAddresses: "[data-customer-addresses]",
  addressCountrySelect: "[data-address-country-select]",
  addressContainer: "[data-address]",
  toggleAddressButton: "button[aria-expanded]",
  cancelAddressButton: 'button[type="reset"]',
  deleteAddressButton: "button[data-confirm-message]",
};

const attributes = {
  expanded: "aria-expanded",
  confirmMessage: "data-confirm-message",
};

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

function initCustomerAddresses() {
  class CustomerAddresses {
    constructor() {
      this.elements = this._getElements();
      if (Object.keys(this.elements).length === 0) return;
      this._setupCountries();
      this._setupEventListeners();
    }

    _getElements() {
      const container = document.querySelector(selectors.customerAddresses);
      return container
        ? {
            container,
            addressContainer: container.querySelector(
              selectors.addressContainer,
            ),
            toggleButtons: document.querySelectorAll(
              selectors.toggleAddressButton,
            ),
            cancelButtons: container.querySelectorAll(
              selectors.cancelAddressButton,
            ),
            deleteButtons: container.querySelectorAll(
              selectors.deleteAddressButton,
            ),
            countrySelects: container.querySelectorAll(
              selectors.addressCountrySelect,
            ),
          }
        : {};
    }

    _setupCountries() {
      if (Shopify && Shopify.CountryProvinceSelector) {
        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector(
          "AddressCountryNew",
          "AddressProvinceNew",
          {
            hideElement: "AddressProvinceContainerNew",
          },
        );
        this.elements.countrySelects.forEach((select) => {
          const formId = select.dataset.formId;
          // eslint-disable-next-line no-new
          new Shopify.CountryProvinceSelector(
            `AddressCountry_${formId}`,
            `AddressProvince_${formId}`,
            {
              hideElement: `AddressProvinceContainer_${formId}`,
            },
          );
        });
      }
    }

    _setupEventListeners() {
      this.elements.toggleButtons.forEach((element) => {
        element.addEventListener("click", this._handleAddEditButtonClick);
      });
      this.elements.cancelButtons.forEach((element) => {
        element.addEventListener("click", this._handleCancelButtonClick);
      });
      this.elements.deleteButtons.forEach((element) => {
        element.addEventListener("click", this._handleDeleteButtonClick);
      });

      // Close popup when clicking overlay background
      document.querySelectorAll(".c-edit-address").forEach((popup) => {
        popup.addEventListener("click", (event) => {
          if (event.target === popup) {
            const cancelButton = popup.querySelector(
              selectors.cancelAddressButton,
            );
            if (cancelButton) {
              this._handleCancelButtonClick({ currentTarget: cancelButton });
            }
          }
        });
      });
    }

    _toggleExpanded(target) {
      target.setAttribute(
        attributes.expanded,
        (target.getAttribute(attributes.expanded) === "false").toString(),
      );
    }

    _handleAddEditButtonClick = ({ currentTarget }) => {
      this._toggleExpanded(currentTarget);

      const formId = currentTarget.getAttribute("aria-controls");
      const popup = document.getElementById(formId);
      if (popup) {
        popup.classList.add("is-active");
        document.body.style.overflow = "hidden"; // prevent background scroll
      }
    };

    _handleCancelButtonClick = ({ currentTarget }) => {
      this._toggleExpanded(
        currentTarget
          .closest(selectors.addressContainer)
          .querySelector(`[${attributes.expanded}]`),
      );
      const popup = currentTarget.closest(".c-edit-address");

      if (popup) {
        popup.classList.remove("is-active");
        document.body.style.overflow = ""; // re-enable background scroll
      }
    };

    _handleDeleteButtonClick = ({ currentTarget }) => {
      // eslint-disable-next-line no-alert
      if (confirm(currentTarget.getAttribute(attributes.confirmMessage))) {
        Shopify.postLink(currentTarget.dataset.target, {
          parameters: { _method: "delete" },
        });
      }
    };
  }

  new CustomerAddresses();
}

initCustomerAddresses();

export { initCustomerAddresses };
